<template>
  <div>
    <b-modal
      id="settingsPageFrameModal"
      ref="settingsPageFrameModal"
      title="Opções do Card"
      size="xl"
      centered
      hide-footer
      @close="$emit('onClose')"
      @hide="$emit('onClose')"
    >
      <template>
        <!-- CONFIGURAÇÃO DE COR DE FUNDO -->
        <div v-if="showSlides" class="row py-2">
          <div class="col-12 py-2">
            <setting-frame-background-color
              :item="activeSettingsItem"
              @onChangeBackgroundColor="onChangeBackgroundColor"
            />
          </div>
       
          <!-- CONFIGURAÇÃO DE IMAGEM DE FUNDO -->
          <div class="col-12 py-2">
              <setting-frame-background-image
                  :url="activeSettingsItem.backgroundImage.uri != null || activeSettingsItem.backgroundImage.uri != '' ? activeSettingsItem.backgroundImage.uri : ''"
                  @onChangeBackgroundImage="onChangeBackgroundImage"
              />
          </div>
          
          <!-- CONFIGURAÇÃO DE PONTO FOCAL DA IMAGEM DE FUNDO (PRECISA TER IMAGEM PARA MOSTRAR) -->
          <div class="col-12 py-2" v-if="activeSettingsItem.backgroundImage.uri != null">
              <setting-frame-background-image-focal-point
                  :url="activeSettingsItem.backgroundImage.uri"
                  :initialPosition="activeSettingsItem.extra.background_image_focal_point"
                  @onChangeBackgroundImageFocalPoint="onChangeBackgroundImageFocalPoint"
              />
          </div>

          <!-- CONFIGURAÇÃO DE OPACIDADE DA IMAGEM DE FUNDO (PRECISA TER IMAGEM PARA MOSTRAR) -->
          <div class="col-12 py-2" v-if="activeSettingsItem.backgroundImage.uri != null">
              <setting-frame-background-image-opacity
                  :item="activeSettingsItem"
                  @onChangeBackgroundImageOpacity="onChangeBackgroundImageOpacity"
              />
          </div>
        </div>

        <div class="mt-3 d-flex justify-content-between">
            <button class="btn btn-secondary py-2" @click="$emit('onClose')">
              Cancelar
            </button>
            
            <button class="btn btn-primario py-2" @click="saveItemChanges">
              Salvar
            </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>


<script>
import ImageCarousel from "@/components/molecules/ImageCarousel.vue";
import uploadFiles from "@/mixins/uploadFiles";
import SettingFrameBackgroundColor from '../atoms/SettingFrameBackgroundColor.vue';
import SettingFrameBackgroundImageOpacity from '../atoms/SettingFrameBackgroundImageOpacity.vue';
import SettingFrameBackgroundImageFocalPoint from "../atoms/SettingFrameBackgroundImageFocalPoint.vue";
import SettingFrameBackgroundImage from "../atoms/SettingFrameBackgroundImage.vue";
import BaseImage from "../atoms/BaseImage.vue";

export default {
  name: "ModalSettingsFrame",
  data() {
    return {
      activeSettingsItem: {},
      activeSettingsItemIndex: null,
      getActivePosts:[],
      mainImagens: [],
      mainImagensGallery: [],
      showSlides: false,
      backgroundImageOpacityDefalut: 80,
      backgroundImageFocalPoint: {
        x: 50,
        y: 50,
      },
    };
  },
  mixins: [uploadFiles],
  components: {
    ImageCarousel,
    SettingFrameBackgroundColor,
    SettingFrameBackgroundImage,
    SettingFrameBackgroundImageFocalPoint,
    SettingFrameBackgroundImageOpacity,
    BaseImage
},
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    settingsPageFrameModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    settingsPageFrameModal() {
      if (this.settingsPageFrameModal) {
        this.$refs.settingsPageFrameModal.show();
        setTimeout(() => {
          this.showSlides = true;
        }, 400);
      } else {
        this.$refs.settingsPageFrameModal.hide();
        this.showSlides = false;
        this.$emit("onClose");
      }
    },
    activeItem() {
      this.mainImagens = []
      this.mainImagensGallery = []
      this.activeSettingsItem = this.activeItem;
      if(!this.activeSettingsItem.coverImage) {
        this.deletePhoto('card')
      }
      if(!this.activeSettingsItem.backgroundImage) {
        this.deletePhoto('mainContent')
      }
      this.activeSettingsItem.frameContent.forEach(element => {
        if(element.frameType == 'gallery'){
            var gallery = element.frameContent.items
            gallery.forEach(imagens => {
                this.mainImagensGallery.push({ 'mainImage' : imagens.image.url })
         });
        }
      });
    },
  },
  methods: {
    onChangeBackgroundImageOpacity(event) {
      this.$set(this.activeSettingsItem.extra, 'background_image_opacity', event);
    },
    resetSettings() {
      this.activeSettingsItem.extra.background_color = null;
    },
    onChangeBackgroundColor(event) {
        if (event.backgroundColor) {
            this.activeSettingsItem.extra.background_color = event.backgroundColor;
        } else {
            this.resetSettings();
        }
    },
    onChangeBackgroundImage(event) {
      this.activeSettingsItem.backgroundImage.uri = event;

      this.onChangeBackgroundImageOpacity(this.backgroundImageOpacityDefalut);
      this.onChangeBackgroundImageFocalPoint(this.backgroundImageFocalPoint);
    },
    deletePhoto(typeCard) {
      if(typeCard === "card") {
         this.activeSettingsItem.coverImage = {'uri': null, 'id': null,'width': null, 'height': null}
      } else if (typeCard === "mainContent") {
        this.activeSettingsItem.backgroundImage = {'uri': null, 'id': null,'width': null, 'height': null}
      }
    },
    onChangeBackgroundImageFocalPoint(event) {
        if (this.activeSettingsItem.extra.background_image_focal_point == null) {
            this.activeSettingsItem.extra.background_image_focal_point = this.backgroundImageFocalPoint;
        }

        this.$set(this.activeSettingsItem.extra.background_image_focal_point, 'x', event.x);
        this.$set(this.activeSettingsItem.extra.background_image_focal_point, 'y', event.y);
    },
    handleUpdateEditButton(e) {
      this.$store.dispatch("dashboardModule/UPDATE_FRAME", [
        this.pageFrameIndex,
        this.activeSettingsItemIndex,
        this.activeSettingsItem,
      ]);
      this.$emit("activeSettings", this.activeSettingsItem);
      this.$refs.settingsPageFrameModal.hide();
      this.$emit("onClose");
      e.preventDefault();
    },
    saveItemChanges() {
      this.$store.dispatch("dashboardModule/UPDATE_PAGE_FRAME", [
        this.activeSettingsItem
      ]);
      this.$refs.settingsPageFrameModal.hide();
      this.$emit("onClose");
      this.$emit("activeSettings", this.activeSettingsItem);
    },
  },
};
</script>

<style>
.carousel-3d-container{
  min-height: 125px !important;
}

.crosshairs{
		position: absolute;
		font-size: 32px;
		pointer-events: none;
		transform: translate(-15px, -12px);
		z-index: 100;
		color:white;
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalSettingsPageFrame.vue